<template>
  <div
    id="app"
    v-if="showUpload"
    :style="{ height: appStatus === 1 ? '5rem' : '30vh' }"
  >
    <div id="upload-top">
      <div id="upload-title">上传任务</div>
      <div id="app-btn">
        <div
          v-bind:title="'最小化'"
          @click="appStatus = 1"
          v-if="appStatus !== 1"
        >
          <el-image
            style="height: 15px"
            :src="require('@/assets/img/globalUpload/zoom_out.png')"
            fit="contain"
          >
          </el-image>
        </div>
        <div
          v-bind:title="'最小化'"
          @click="appStatus = 2"
          v-if="appStatus !== 2"
        >
          <el-image
            style="height: 15px"
            :src="require('@/assets/img/globalUpload/zoom_in.png')"
            fit="contain"
          >
          </el-image>
        </div>
        <div v-bind:title="'关闭'" @click="handleClose()">
          <el-image
            style="height: 15px; margin-left: 5px"
            :src="require('@/assets/img/globalUpload/close.png')"
            fit="contain"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div id="upload-result">{{ uploadResult }}</div>
    <!-- <el-table :data="chunkObjList" style="width: 100%" height="calc(100% - 4rem)">
      <el-table-column prop="pnNames" label="PN码" show-overflow-tooltip align="center" header-align="center" width="width"> </el-table-column>
      <el-table-column prop="modelNames" label="设备型号" show-overflow-tooltip align="center" header-align="center" width="width"> </el-table-column>
      <el-table-column prop="suit" label="产品系列" show-overflow-tooltip align="center" header-align="center" width="width"> </el-table-column>
      <el-table-column prop="status" label="状态" show-overflow-tooltip align="center" header-align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">{{ scope.row.percent.toFixed(2) + '%' }}</span>
          <span v-else>{{ scope.row.status | statusTextFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="70">
        <template slot-scope="scope">
          <span v-bind:title="'开始'" class="iconfont" v-if="scope.row.status === 2" @click="handleClickBtn(scope.$index, 1)">&#xe68a;</span>
          <span v-bind:title="'暂停'" class="iconfont" v-if="[0, 1].indexOf(scope.row.status) !== -1" @click="handleClickBtn(scope.$index, 2)"
            >&#xe67b;</span
          >
          <span class="iconfont" v-if="scope.row.status === 3" style="cursor: default">&#xe60b;</span>
          <span v-bind:title="'重试'" class="iconfont" v-if="[-2, -1].indexOf(scope.row.status) !== -1" @click="handleClickBtn(scope.$index, 1)"
            >&#xe708;</span
          >
          <span v-bind:title="'取消'" class="iconfont" v-if="[0, 1, 2].indexOf(scope.row.status) !== -1" @click="handleClickBtn(scope.$index, -1)"
            >&#xe619;</span
          >
        </template>
      </el-table-column>
    </el-table> -->

    <!-- <el-upload ref="packUpload" :show-file-list="false" :on-change="handleChange" action="" :auto-upload="false">
      <el-button slot="trigger" type="primary">上传</el-button>
    </el-upload> -->

    <div id="upload-table">
      <div id="table-title">
        <div class="title-class">产品编号</div>
        <div class="title-class">产品名称</div>
        <div class="title-class">产品系列</div>
        <div class="title-class">状态</div>
        <div class="title-class">操作</div>
      </div>
      <div id="table-content">
        <div
          v-for="(item, index) in chunkObjList"
          :key="item.uid"
          class="upload-out-div"
        >
          <div class="upload-in-div">
            <el-tooltip
              v-if="item.params.proNum && item.params.proNum.length > 7"
              effect="dark"
              :content="item.params.proNum"
              placement="top-start"
            >
              <span> {{ item.params.proNum | ellipsis(7) }} </span>
            </el-tooltip>
            <div v-else>{{ item.params.proNum }}</div>
          </div>
          <div class="upload-in-div">
            <el-tooltip
              v-if="item.params.proName && item.params.proName.length > 7"
              effect="dark"
              :content="item.params.proName"
              placement="top-start"
            >
              <span> {{ item.params.proName | ellipsis(7) }} </span>
            </el-tooltip>
            <div v-else>{{ item.params.proName }}</div>
          </div>
          <div class="upload-in-div">
            <el-tooltip
              v-if="item.params.proType && item.params.proType.length > 7"
              effect="dark"
              :content="item.params.proType"
              placement="top-start"
            >
              <span> {{ item.params.proType | ellipsis(7) }} </span>
            </el-tooltip>
            <div v-else>{{ item.params.proType }}</div>
          </div>
          <div class="upload-in-div">
            <span v-if="item.status === 1">{{
              item.percent.toFixed(2) + '%'
            }}</span>
            <span v-else-if="item.status === 3" style="color: #10b08a"
              >上传成功</span
            >
            <span v-else-if="item.status === -2" style="color: #e82037"
              >上传失败</span
            >
            <span v-else>{{ item.status | statusTextFilter }}</span>
          </div>

          <div class="upload-in-div task-btn">
            <div
              v-bind:title="'开始'"
              v-if="item.status === 2"
              @click="handleClickBtn(index, 1)"
            >
              <el-image
                style="height: 24px"
                :src="require('@/assets/img/globalUpload/task_play.png')"
                fit="contain"
              >
              </el-image>
            </div>
            <div
              v-bind:title="'暂停'"
              v-if="[0, 1].indexOf(item.status) !== -1"
              @click="handleClickBtn(index, 2)"
            >
              <el-image
                style="height: 24px"
                :src="require('@/assets/img/globalUpload/task_pause.png')"
                fit="contain"
              >
              </el-image>
            </div>
            <div
              v-bind:title="'重试'"
              v-if="[-2, -1].indexOf(item.status) !== -1"
              @click="handleClickBtn(index, 1)"
            >
              <el-image
                style="height: 24px"
                :src="require('@/assets/img/globalUpload/task_refresh.png')"
                fit="contain"
              >
              </el-image>
            </div>
            <div
              v-bind:title="'取消'"
              v-if="[0, 1, 2].indexOf(item.status) !== -1"
              @click="handleClickBtn(index, -1)"
            >
              <el-image
                style="height: 24px"
                :src="require('@/assets/img/globalUpload/task_close.png')"
                fit="contain"
              >
              </el-image>
            </div>
          </div>
          <span
            class="progress-span"
            :style="progressStyle(item, index)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
export default {
  name: 'GlobalUpload',
  filters: {
    statusTextFilter(val) {
      switch (val) {
        case -2:
          return '上传失败'
        case -1:
          return '已取消'
        case 0:
          return '排队中'
        // case 1:
        //   return '上传中'
        case 2:
          return '暂停'
        case 3:
          return '上传成功'
        default:
          return '上传失败'
      }
    }
  },
  beforeDestroy() {
    this.resetData()
  },
  props: {
    showUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chunkSize: 1048576, // 1M
      // chunkSize: 20971520, // 20M
      appStatus: 2, //  1-最小化    2-最大化
      uploading: false, // 当时是否正在上传
      uploadIndex: 0, // 当前正在上传的index
      chunkObjList: [],
      successNum: 0,
      failedFlag: false
    }
  },
  computed: {
    // vuex列表
    uploadList() {
      const uploadList = []
      uploadList.push(...this.$store.state.uploadList)
      return uploadList
    },
    // 上传结果
    uploadResult() {
      // 统计结果
      const allNum = this.chunkObjList.length
      let successNum = 0
      let pauseNum = 0
      let cancelNum = 0
      let failedNum = 0
      this.chunkObjList.forEach((item) => {
        switch (item.status) {
          case -2:
            failedNum++
            break

          case -1:
            cancelNum++
            break

          case 2:
            pauseNum++
            break

          case 3:
            successNum++
            break

          default:
            break
        }
      })

      let result = ''
      if (this.uploading) {
        // 有任务时，若有在上传的，则显示“正在上传(1/2)”，分子为成功任务数+1，分母为当前表内任务总数
        result = `正在上传(${successNum + 1}/${allNum})`
      } else {
        // 能上传的任务都处理完成时，若有失败任务则显示“有n个任务上传失败。”若有暂停或取消任务时显示“有n个任务被暂停或取消 。”若上传均成功则显示“上传完成”，描述顺序即为显示优先级
        if (successNum === allNum) {
          result = '上传完成'
        } else {
          result =
            (failedNum > 0 ? `有${failedNum}个任务上传失败` : '') +
            (failedNum > 0 && pauseNum + cancelNum > 0 ? '，' : '') +
            (pauseNum + cancelNum > 0
              ? `有${pauseNum + cancelNum}个任务被暂停或取消`
              : '')
        }
      }

      return result
    },
    // 当前是否有未完成的任务
    isFinish() {
      return !(
        this.uploading ||
        this.chunkObjList.findIndex((obj) => {
          return [0, 1, 2].indexOf(obj.status) !== -1
        }) !== -1 ||
        this.failedFlag
      )
    },
    // 进度条
    progressStyle() {
      return (item, index) => {
        return `width: ${
          this.uploadIndex === index && this.uploading ? item.percent + '%' : 0
        };`
      }
    }
  },
  watch: {
    uploadList(newVal, oldVal) {
      // 获取新增的上传任务
      const oldUidList = oldVal.map((item) => {
        return item.file.uid
      })
      const addList = newVal.filter((item) => {
        return oldUidList.indexOf(item.file.uid) === -1
      })

      if (addList.length > 0) {
        // 限制任务数
        if (this.chunkObjList.length - this.successNum > 9) {
          this.$confirm(
            '上传任务数量上限为10个，请等待旧任务结束后再添加新任务',
            '上传任务数量已达上限',
            {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning'
            }
          ).then(() => {})
          return
        }

        // 显示上传组件
        if (!this.showUpload) {
          this.$emit('update:showUpload', true)
        }
        // 构造任务
        this.createTask(addList[0])
      }
    },
    // 关闭时清空数据
    showUpload(val) {
      if (!val) {
        this.resetData()
      }
    }
  },
  methods: {
    // 创建任务
    createTask(uploadObj) {
      // 处理参数
      const {
        // 文件
        file,
        // 业务参数
        params,
        // 其他参数
        replaceId
      } = uploadObj

      const chunkObj = {
        // 状态参数
        file,
        uid: file.uid,
        fileName: file.name,
        chunkNames: [], // 切片名称
        status: 0, // 上传状态
        percent: 0, // 上传百分比
        percentCount: 0, // 单片所占百分比
        curChunk: 0, // 当前切片数
        chunkListLength: Math.ceil(file.size / this.chunkSize), // 总切片数
        suffix: /\.([0-9A-z]+)$/.exec(file.name)[0], // 文件后缀
        md5: new SparkMD5.ArrayBuffer(), // 根据文件内容生产md5
        // 业务参数
        params
      }

      // 判断替换或添加
      if (replaceId) {
        for (let i = 0; i < this.chunkObjList.length; i++) {
          if (this.chunkObjList[i].uid === replaceId) {
            this.$set(this.chunkObjList, i, chunkObj)
            break
          }
        }
      } else {
        this.chunkObjList.push(chunkObj)
      }

      // 统计各个状态的pn
      this.statPn()

      // 调用上传
      this.sendRequest()
    },
    // 统计各个状态的pn
    statPn() {
      // 正在上传或等待上传的uid pns {pns, uid}
      const pnList = {}
      // 已取消或上传失败的uid pns {pns, uid}
      const failedPnList = {}
      this.chunkObjList.forEach((obj) => {
        const pns = obj.params.proNum || []
        // 正在上传或等待上传的
        if ([0, 1, 2].indexOf(obj.status) !== -1) {
          pnList[pns] = obj.uid
        }
        // 已取消或上传失败的
        if ([-2, -1].indexOf(obj.status) !== -1) {
          failedPnList[pns] = obj.uid
        }
      })
      this.$store.commit('updateUploadingPnList', pnList)
      this.$store.commit('updateFailedPnList', failedPnList)
    },
    // 任务点击
    handleClickBtn(index, val) {
      const chunkObj = this.chunkObjList[index]
      chunkObj.status = val

      // 统计各个状态的pn
      this.statPn()

      if (val === 1) {
        // 开始
        // 有任务则排队
        if (this.uploading) {
          chunkObj.status = 0
        } else {
          this.sendRequest()
        }
      } else {
        // 若是正在执行的任务就开始下一个任务
        if (index === this.uploadIndex) {
          // // 清除定时器
          // clearInterval(this.intervalId)

          this.uploading = false
          this.sendRequest()
        }
      }
    },
    // 发送请求
    sendRequest() {
      if (!this.uploading) {
        for (let i = 0; i < this.chunkObjList.length; i++) {
          const chunkObj = this.chunkObjList[i]
          const file = chunkObj.file
          // 开始第一个排队的
          if ([0, 1].indexOf(chunkObj.status) !== -1) {
            // 改状态
            this.uploading = true
            this.uploadIndex = i
            chunkObj.status = 1

            // 失败方法
            const failed = () => {
              chunkObj.status = -2
              this.uploading = false
              this.failedFlag = true
              // 统计各个状态的pn
              this.statPn()

              this.sendRequest()
            }

            // 完成方法
            const complete = () => {
              // 调用请求
              const { params, fileName, chunkNames } = chunkObj
              const {
                versionNumber,
                updateContent,
                productId,
                forceUpdate,
                list,
                type,
                remark
              } = params

              this.$http({
                url: this.$http.adornUrl('/api/v1/ota/complete'),
                method: 'post',

                data: this.$http.adornData({
                  fileName,
                  chunkNames,
                  productNumber: params.proNum,
                  version: params.versionNumber
                })
              })
                .then((res) => {
                  if (res.resp_code === 0) {
                    const data = res.data
                    if (type === 4) {
                      // 新增版本
                      this.$http({
                        url: this.$http.adornUrl('/api/v1/ota/save'),
                        method: 'post',
                        data: this.$http.adornData({
                          filePath: '/' + data,
                          versionNumber,
                          updateContent,
                          productId,
                          forceUpdate,
                          list: list.length === 0 ? null : list,
                          note: remark,
                          fileName: data
                        })
                      })
                        .then((res) => {
                          if (res.resp_code === 0) {
                            suncessFn()
                          } else {
                            console.log('save-failed')
                            failed()
                          }
                        })
                        .catch(() => {
                          console.log('save-failed')
                          failed()
                        })
                    } else if (params.type === 5) {
                      // 编辑版本
                      this.$http({
                        url: this.$http.adornUrl(
                          '/api/app/updateProductVersion'
                        ),
                        method: 'post',
                        data: this.$http.adornData({
                          delete: '2', // delete传 1就是删除原来的安装包  delete传2 就是上传新的安装包
                          fileName: data,
                          versionId: params.versionId,
                          updateContent,
                          forceUpdate,
                          list: list.length === 0 ? null : list,
                          note: remark
                        })
                      })
                        .then((res) => {
                          if (res.resp_code === 0) {
                            suncessFn()
                          } else {
                            console.log('save-failed')
                            failed()
                          }
                        })
                        .catch(() => {
                          console.log('save-failed')
                          failed()
                        })
                    }
                    const suncessFn = () => {
                      // 统计成功
                      chunkObj.status = 3
                      this.successNum++
                      this.failedFlag = false
                      this.uploading = false

                      // 统计各个状态的pn
                      this.statPn()

                      this.sendRequest()
                      console.log('refreshDataList')
                      this.$emit('refreshDataList')
                    }
                  } else {
                    console.log('complete-failed')
                    failed()
                  }
                })
                .catch(() => {
                  console.log('complete-failed')
                  failed()
                })
            }

            // 边切分边上传
            let chunk
            const fread = new FileReader()
            fread.onload = (e) => {
              const ceilBuffer = e.target.result
              const chunkName = `${chunkObj.uid}_${chunkObj.curChunk}${chunkObj.suffix}`
              const { params } = chunkObj
              // 发送请求
              const formdata = new FormData()
              formdata.append('chunk', chunk)
              formdata.append('fileName', chunkName)
              formdata.append('productNumber', params.proNum)
              formdata.append('version', params.versionNumber)
              this.$http({
                url: this.$http.adornUrl(
                  '/api/v1/ota/uploadFiles?t=' + new Date().getTime()
                ),
                method: 'post',
                timeout: 1000 * 60,
                data: formdata
              })
                .then((res) => {
                  if (res.resp_code === 0) {
                    if (chunkObj.percentCount === 0) {
                      chunkObj.percentCount = 100 / chunkObj.chunkListLength
                    }
                    chunkObj.percent += chunkObj.percentCount
                    chunkObj.md5.append(ceilBuffer)
                    chunkObj.curChunk++
                    chunkObj.chunkNames.push(chunkName)

                    console.log('chunkObj', chunkObj)
                    if (chunkObj.curChunk < chunkObj.chunkListLength) {
                      uploadNext()
                    } else {
                      console.log('finish upload')
                      chunkObj.md5.end()
                      complete()
                    }
                  } else {
                    console.log('send failed', chunkObj.curChunk + 1)
                    failed()
                  }
                })
                .catch(() => {
                  console.log('send failed', chunkObj.curChunk + 1)
                  failed()
                })
            }
            fread.onerror = (err) => {
              console.log('转换文件格式发生错误', err)
              failed()
            }

            // 下一个
            const uploadNext = () => {
              if (chunkObj.status !== 1) return

              const start = chunkObj.curChunk * this.chunkSize
              const end =
                start + this.chunkSize >= file.size
                  ? file.size
                  : start + this.chunkSize
              chunk = file.slice(start, end) // 用Blob.slice()切割
              fread.readAsArrayBuffer(chunk)
            }

            console.log('start upload')
            uploadNext()
          }

          if (this.uploading) {
            break
          }
        }
      }
    },
    // 关闭
    handleClose() {
      if (!this.isFinish) {
        this.$confirm('列表中有未完成的上传任务，确定放弃上传吗?', '放弃上传', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$emit('update:showUpload', false)
          })
          .catch(() => {})
      } else {
        this.$emit('update:showUpload', false)
      }
    },
    // 重置数据
    resetData() {
      this.appStatus = 2
      this.uploading = false
      this.uploadIndex = 0
      this.chunkObjList = []
      this.successNum = 0
      this.$store.commit('clearUpload')
      this.$store.commit('updateUploadingPnList', {})
      this.$store.commit('updateFailedPnList', {})
    },
    // 文件改变
    handleChange(file) {
      const uploadObj = {
        file: file.raw,
        fileName: file.name
      }
      this.$store.commit('addUpload', uploadObj)
    }
  }
}
</script>

<style lang="scss" scoped>
$lineHeight: 2.5rem;
$paddingLeft: 20px;
// .iconfont {
//   cursor: pointer;
// }
#app {
  // 上传窗口
  overflow: hidden;
  font-size: 0.875rem;
  z-index: 999;
  background: #fff;
  position: absolute;
  right: 18px;
  bottom: 18px;
  width: 30vw;
  border-radius: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #494d52;
  border: 0.5px solid #bbbbbb;
  #upload-top {
    display: flex;
    display: -webkit-flex; /* Safari */
    justify-content: space-between;
    background: #d3d5d7;
    height: $lineHeight;
    line-height: $lineHeight;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    #upload-title {
      padding-left: $paddingLeft;
    }
    #app-btn {
      display: flex;
      align-items: center;
      padding-right: $paddingLeft;
      cursor: pointer;
      div {
        vertical-align: middle;
      }
      div:hover {
        transform: translateY(-1px);
      }
    }
  }

  #upload-result {
    background: #f4f4f4;
    color: #409eff;
    height: $lineHeight;
    line-height: $lineHeight;
    padding-left: $paddingLeft;
  }

  #upload-table {
    height: calc(100% - 4rem);
    color: #71757a;
    #table-title {
      height: 3rem;
      display: flex;
      align-items: center;
      overflow-y: scroll;
      border-bottom: 0.1px solid #dbdbdb;
      .title-class {
        width: 20%;
        font-weight: 500;
        text-align: center;
      }
    }
    #table-content {
      height: calc(100% - 4rem);
      overflow-y: scroll;
      overflow-x: auto;
      .upload-out-div {
        height: 3rem;
        display: flex;
        align-items: center;
        border-bottom: 0.1px solid #dbdbdb;
        position: relative;
        .upload-in-div {
          width: 20%;
          text-align: center;
        }
        .task-btn {
          display: flex;
          justify-content: center;
          cursor: pointer;
          div + div {
            margin-left: 10px;
          }
          div:hover {
            transform: translateY(-1px);
          }
        }
        .progress-span {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          z-index: -1;
          background: #87daff;
        }
      }
    }
  }
}
</style>
